import { defineMessages } from 'react-intl';

import { JOB_STATUS } from '../../../common/constants';

export const JOB_SEARCH_DELAY = 700;

export const DASHBOARD_JOB_CARD_SOURCE = 'dashboard_job_card';

export const JOBS_PER_PAGE = 5;

export const DRAFT_DELETE_SUCCESS = {
  id: 'your.draft.has',
  defaultMessage: 'Your draft has been deleted',
};

export const CLOSE_JOB_ERROR = {
  id: 'modules.CompanyDashboardNew.constants.close.job.error',
  defaultMessage:
    'There was an error closing the <b>{jobTitle}</b> job, please try again later',
};

export const SORT_LABELS = defineMessages({
  DATE_MODIFIED: {
    id: 'interactive-date-modified',
    defaultMessage: 'Date Modified',
  },
  DATE_POSTED: {
    id: 'interactive-date-posted',
    defaultMessage: 'Date Posted',
  },
  ALPHABETICAL: {
    id: 'interactive-alphabetical',
    defaultMessage: 'Alphabetical',
  },
  JOB_EXPIRY: {
    id: 'interactive-job-expiry',
    defaultMessage: 'Job Expiry',
  },
});

export const SORT_OPTIONS = {
  DATE_MODIFIED: {
    message: SORT_LABELS.DATE_MODIFIED,
    value: 'updatedAt DESC',
  },
  DATE_POSTED: {
    message: SORT_LABELS.DATE_POSTED,
    value: 'createdAt DESC',
  },
  ALPHABETICAL: {
    message: SORT_LABELS.ALPHABETICAL,
    value: 'title ASC',
  },
  JOB_EXPIRY: {
    message: SORT_LABELS.JOB_EXPIRY,
    value: 'expiryDate ASC',
  },
};

export const JobTabEnum = {
  ALL: 'ALL',
  ACTIVE: 'ACTIVE',
  DRAFTS: 'DRAFTS',
  INACTIVE: 'INACTIVE',
  IN_REVIEW: 'IN_REVIEW',
} as const;

export type JobTabEnum = (typeof JobTabEnum)[keyof typeof JobTabEnum];

export const JOB_TAB_LABELS = defineMessages({
  [JobTabEnum.ALL]: {
    id: 'interactive-all-jobs',
    defaultMessage: 'All Jobs',
  },
  [JobTabEnum.ACTIVE]: {
    id: 'text-active',
    defaultMessage: 'Active',
  },
  [JobTabEnum.INACTIVE]: {
    id: 'interactive-inactive',
    defaultMessage: 'Inactive',
  },
  [JobTabEnum.IN_REVIEW]: {
    id: 'text-in-review',
    defaultMessage: 'In Review',
  },
  [JobTabEnum.DRAFTS]: {
    id: 'interactive-all-drafts',
    defaultMessage: 'Drafts',
  },
});

export const JOB_TABS_PARAMS = {
  [JobTabEnum.ALL]: {
    params: {
      where: {
        status: [JOB_STATUS.OPEN, JOB_STATUS.IN_REVIEW, JOB_STATUS.CLOSED],
      },
    },
  },
  [JobTabEnum.ACTIVE]: {
    params: {
      where: {
        status: [JOB_STATUS.OPEN],
      },
    },
  },
  [JobTabEnum.INACTIVE]: {
    params: {
      where: {
        status: [JOB_STATUS.CLOSED],
      },
    },
  },
  [JobTabEnum.IN_REVIEW]: {
    params: {
      where: {
        status: [JOB_STATUS.IN_REVIEW],
      },
    },
  },
};

export const COMPANY_CREATED_ALERT = defineMessages({
  title: {
    id: 'text-company-created',
    defaultMessage: 'Company Created',
  },
  content: {
    id: 'text-verify-company-legal-doc',
    defaultMessage:
      "Verify your company's legal{br}documents to start posting jobs",
  },
});

export const JOB_UPDATE_ALERT = defineMessages({
  title: {
    id: 'text-job-post-updated',
    defaultMessage: 'Job post updated',
  },
  content: {
    id: 'text-share-job-social-media',
    defaultMessage: 'Candidates will directly be able to see this information',
  },
});

export const JOB_ENHANCED_ALERT = defineMessages({
  title: {
    id: 'text-job-post-updated',
    defaultMessage: 'Job post updated',
  },
  content: {
    id: 'text-share-job-social-media',
    defaultMessage: 'Candidates will directly be able to see this information',
  },
});
